import { api } from '@services';

interface IRequest {
  tagsIds: string[];
}

const deleteTags = async ({ tagsIds }: IRequest): Promise<void> => {
  await api.post(`/tags/deleteTags`, { tagsIds });
};

export { deleteTags };
